/**
 * Cart snapshot save/restore across manual logout + SSO re-login.
 * Selective session/auth storage cleanup (never localStorage.clear).
 */
(function (global) {
  var CART_KEY_PREFIX = "ds2_saved_cart_";
  var RESTORE_FLAG_PREFIX = "ds2_cart_restore_attempted_";

  var SESSION_KEYS_TO_CLEAR = [
    "apiCallsDoneThisSession",
    "apiCallsPending",
    "landed_SFront",
    "landed_SFront_filter",
    "ds2PremFreeRibbonOverride",
    "ds2HadFreePremInCart",
    "ds2CheckedOutWithFreePrem",
    "integrations_clicked",
    "page_changed",
    "price-max",
    "cableData",
    "deviceGroups",
    "checkedItems",
    "cartItems",
    "subscription_call",
    "reloaded",
    "reloaded-x",
    "reloaded-y",
    "lastVisitedPage",
  ];

  var LOCAL_KEYS_TO_CLEAR = [
    "fetchData",
    "fetchDone",
    "hasFreeSubscriptionItem",
    "buttonsDisabled",
    "cart_error_msg",
    "__ui",
    "total_device_count",
    "from_service",
    "quantity",
    "minPrice",
    "maxPrice",
    "cart",
  ];

  function cartStorageKey(customerKey) {
    return CART_KEY_PREFIX + String(customerKey);
  }

  function restoreFlagKey(customerKey) {
    return RESTORE_FLAG_PREFIX + String(customerKey);
  }

  function saveCartSnapshot(customerKey) {
    return fetch("/cart.js", { cache: "no-store" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var key = cartStorageKey(customerKey);
        if (!cart || !cart.items || cart.items.length === 0) {
          try {
            localStorage.removeItem(key);
          } catch (e) {}
          return;
        }
        var payload = {
          savedAt: Date.now(),
          items: cart.items.map(function (item) {
            return {
              id: item.variant_id || item.id,
              quantity: item.quantity,
            };
          }),
        };
        try {
          localStorage.setItem(key, JSON.stringify(payload));
        } catch (e) {}
      })
      .catch(function () {});
  }

  function restoreCartSnapshot(customerKey) {
    var flagKey = restoreFlagKey(customerKey);
    if (sessionStorage.getItem(flagKey) === "1") {
      return Promise.resolve();
    }
    sessionStorage.setItem(flagKey, "1");

    var storageKey = cartStorageKey(customerKey);
    var raw;
    try {
      raw = localStorage.getItem(storageKey);
    } catch (e) {
      return Promise.resolve();
    }
    if (!raw) {
      return Promise.resolve();
    }

    var snapshot;
    try {
      snapshot = JSON.parse(raw);
    } catch (e) {
      return Promise.resolve();
    }
    if (!snapshot.items || !snapshot.items.length) {
      try {
        localStorage.removeItem(storageKey);
      } catch (e) {}
      return Promise.resolve();
    }

    return fetch("/cart.js", { cache: "no-store" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart && cart.item_count > 0) {
          return "skipped";
        }
        return snapshot.items.reduce(function (chain, item) {
          return chain.then(function () {
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: item.id,
                quantity: item.quantity,
              }),
            });
          });
        }, Promise.resolve());
      })
      .then(function (result) {
        if (result === "skipped") {
          return;
        }
        try {
          localStorage.removeItem(storageKey);
        } catch (e) {}
        if (typeof global.ds2RefreshHeaderCartIcon === "function") {
          global.ds2RefreshHeaderCartIcon();
        }
        if (typeof global.ds2SyncPremVisualizationCartFlags === "function") {
          return fetch("/cart.js", { cache: "no-store" })
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              global.ds2SyncPremVisualizationCartFlags(cart);
            })
            .catch(function () {});
        }
      })
      .catch(function () {});
  }

  function clearSessionStorage(customerKey) {
    var i;
    for (i = 0; i < SESSION_KEYS_TO_CLEAR.length; i++) {
      try {
        sessionStorage.removeItem(SESSION_KEYS_TO_CLEAR[i]);
      } catch (e) {}
    }
    if (customerKey != null) {
      try {
        sessionStorage.removeItem(restoreFlagKey(customerKey));
      } catch (e) {}
    }
  }

  function clearAuthLocalStorage() {
    var i;
    for (i = 0; i < LOCAL_KEYS_TO_CLEAR.length; i++) {
      try {
        localStorage.removeItem(LOCAL_KEYS_TO_CLEAR[i]);
      } catch (e) {}
    }
  }

  function clearAuthCookies() {
    document.cookie =
      "mySessionFlag=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "analyticData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  global.DS2LogoutCart = {
    saveCartSnapshot: saveCartSnapshot,
    restoreCartSnapshot: restoreCartSnapshot,
    clearSessionStorage: clearSessionStorage,
    clearAuthLocalStorage: clearAuthLocalStorage,
    clearAuthCookies: clearAuthCookies,
  };
})(typeof window !== "undefined" ? window : this);
